export default __webpack_public_path__ + "static/comercial-trash-service-single-43a2b18fc3af5f5a75e20fa82b104db2.jpg";